var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step-progress-bar" }, [
    _c("p", { staticClass: "step-title" }, [
      _vm._v("Step " + _vm._s(_vm.step) + ": "),
      _c("b", [_vm._v(_vm._s(_vm.stepTitle))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-progress" },
      _vm._l(_vm.stepCount, function (index) {
        return _c("span", {
          key: index,
          class: { "step-status": true, active: _vm.step >= index },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }